import {
    Button,
    Container,
    Dropdown,
    Form,
    FormGroup,
    Input,
    InputPlaceholder,
    Segment,
    SegmentContent,
    SegmentHeader,
    Toggle,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Deferred, Link, router, useForm, usePage } from '@inertiajs/react';
import { useEffect, useMemo } from 'react';
import RulesList from './components/RulesList';

const CreateOrUpdateView = () => {
    const { target_group, resellers, groups } = usePage().props;
    const { data, setData, errors, post, patch, processing } = useForm({});

    useEffect(() => {
        if (target_group?.id) {
            setData({
                ...target_group,
                groups: target_group?.groups?.map(group => group.id),
                resellers: target_group?.resellers?.map(
                    reseller => reseller.id
                ),
            });
        }
    }, [target_group?.id]);

    const handleSubmit = () => {
        if (!target_group?.id) {
            post('/target-groups', {
                onSuccess: () => router.reload({ only: ['target_group'] }),
            });

            return;
        }

        patch(`/target-groups/${target_group.id}`);
    };

    const title = useMemo(
        () => (target_group?.id ? 'Wijzig doelgroep' : 'Nieuwe doelgroep'),
        [target_group]
    );

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/target-groups'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup>
                            <Deferred
                                data={['resellers']}
                                fallback={
                                    <InputPlaceholder
                                        label='Reseller'
                                        placeholder='Resellers worden geladen...'
                                    />
                                }
                            >
                                <Dropdown
                                    label='Reseller'
                                    multiple
                                    options={Object.keys(resellers || {})?.map(
                                        resellerId => ({
                                            id: resellerId,
                                            name: resellers[resellerId],
                                        })
                                    )}
                                    value={data?.resellers || []}
                                    onChange={value =>
                                        setData('resellers', value)
                                    }
                                    error={errors?.resellers}
                                />
                            </Deferred>
                            <Input
                                label='Naam'
                                required
                                value={data?.name || ''}
                                onChange={event =>
                                    setData('name', event?.target?.value)
                                }
                                error={errors?.name}
                            />
                            <Input
                                label='Label (voor op tabs e.d.)'
                                required
                                value={data?.label || ''}
                                onChange={event =>
                                    setData('label', event?.target?.value)
                                }
                                error={errors?.label}
                            />
                            <Deferred
                                data='groups'
                                fallback={
                                    <InputPlaceholder
                                        label='Groep(en)'
                                        placeholder='Groepen worden geladen...'
                                    />
                                }
                            >
                                <Dropdown
                                    label='Groep(en)'
                                    multiple
                                    options={Object.keys(groups || {})?.map(
                                        groupId => ({
                                            id: groupId,
                                            name: groups[groupId],
                                        })
                                    )}
                                    value={data?.groups || []}
                                    onChange={value => setData('groups', value)}
                                    error={errors?.groups}
                                />
                            </Deferred>
                            <Toggle
                                label='Toepasbaar als status'
                                checked={!!data?.is_status || false}
                                onChange={checked =>
                                    setData('is_status', checked)
                                }
                            />
                            <Toggle
                                label='Toon in filters'
                                checked={!!data?.use_in_filter || false}
                                onChange={checked =>
                                    setData('use_in_filter', checked)
                                }
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <RulesList data={data} onChange={setData} />

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
